import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css", "./style/font.less", "./style/main.less"]
})
export class AppComponent implements OnInit {
  title = "app";
  constructor() {}
  ngOnInit() {}
}



// WEBPACK FOOTER //
// E:/project/muyiwang/svn/project-code/trad-portal/src/app/app.component.ts